<div style="margin-top: 20px;" class="container shippn-homepage-container">
    <div class="row">
        <div class="col-md-12">
            <h1 class="header-underline-black-left"
                style="font-size: 22px;font-weight: bold;margin-bottom: 27px;color: black;">Shipping Cost Calculator:
                International shipping companies rates
            </h1>
            <p
                style="color: black;text-align: left;font-size: 16px;font-weight: 300;margin-top: 30px;margin-bottom: 20px;">
                Enter your package details and get best shipping rates to shop from your favorite country</p>

        </div>

        <div class="col-md-12">
            <div style="box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);border-radius: 5px;">
                <div style="padding: 15px;">
                    <div class="shippn-pricing-width">
                        <h4 style="font-size: 18px;font-weight: bold;margin-bottom: 27px;color: black;">1 - Select the
                            country you want to shop from</h4>
                        <hr style="border-top-color: #707070;">
                        <div class="row">
                            <div class="col-12 col-lg-5">

                                <p
                                    style="color: black;text-align: left;font-size: 16px;font-weight: 300;margin-bottom: 5px;">
                                    Where will you shop from?</p>

                                <div style="position: relative; background-color: white; border-radius: 5px;margin-top: 5px; margin-bottom: 5px; "
                                    class="select--wrapper">
                                    <i class="fas fa-chevron-down"
                                        style="position: absolute; right: 15px; top: 15px;float: right; color: #222222; font-size: 12px;"
                                        aria-hidden="true"></i>

                                    <select
                                        style="-webkit-appearance: none;-moz-appearance: none;appearance: none;width: 100%; border-radius: 5px;height:40px;"
                                        [(ngModel)]="countryFrom" class=" form-control-sm">
                                        <option value="{{hostCountry.code}}" *ngFor="let hostCountry of hostCountries">
                                            <span
                                                *ngIf="hostCountry?.code != 'TR' && hostCountry?.name != 'Turkey'">{{hostCountry?.name}}</span>
                                            <span *ngIf="hostCountry?.code == 'TR' || hostCountry?.name == 'Turkey'"
                                                translate="no">Türkiye</span>
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div style="display: inline-grid;align-items: center;text-align: center;"
                                class="col-lg-2 d-none d-sm-none d-xs-none d-md-none d-lg-block">
                                <img style="width:30px;margin-top: 38px;"
                                    src="../../assets/img/shippn-right-arrow-icon.png" alt="right arrow icon">
                            </div>
                            <div class="col-12 col-lg-5">
                                <p
                                    style="margin-top: 5px;color: black;text-align: left;font-size: 16px;font-weight: 300;margin-bottom: 5px;">
                                    Where do yo want to send it?</p>

                                <div style="position: relative; background-color: #fff;border-radius: 5px;margin-top: 5px; margin-bottom: 5px; cursor: pointer;"
                                    class="select--wrapper">
                                    <i class="fas fa-chevron-down"
                                        style="position: absolute; right: 15px; top: 15px;float: right; color: #222222; font-size: 12px;"
                                        aria-hidden="true"></i>
                                    <select
                                        style="-webkit-appearance: none;-moz-appearance: none;appearance: none; width: 100%; border-radius: 5px;height:40px;"
                                        [(ngModel)]="countryTo" class="form-control-sm">
                                        <option value="{{country.code}}" *ngFor="let country of allCountries">
                                            <span
                                                *ngIf="country.code != 'TR' && country.name != 'Turkey'">{{country.name}}</span>
                                            <span *ngIf="country.code == 'TR' || country.name == 'Turkey'"
                                                translate="no">Türkiye</span>
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <p
                            style="color: black;text-align: left;font-size: 16px;font-weight: 300;margin-top: 10px;margin-bottom: 40px;">
                            Your products will be delivered within 1-5 business days via express shipping. In
                            partnership with best couriers.</p>

                        <h4 style="font-size: 18px;font-weight: bold;margin-bottom: 27px;color: black;">2 - Enter your
                            package dimensions</h4>
                        <hr style="border-top-color: #707070;">

                        <form ngNativeValidate [formGroup]="form">
                            <div class="row">
                                <div class="col-12 col-lg-5">
                                    <p
                                        style="color: black;text-align: left;font-size: 16px;font-weight: 300;margin-bottom: 5px;">
                                        My package's estimated weight is</p>
                                    <input (keypress)="priceText = 0;oldPriceText =0"
                                        (change)="priceText = 0; oldPriceText =0;" type="number" step="0.01"
                                        formControlName="weight"
                                        [ngClass]="{'shippn-border-red':form.get('weight').touched && form.get('weight').invalid}"
                                        placeholder="Weight: 0" class="form-control form-control-sm shippn-input"
                                        onwheel="this.blur()">
                                    <div style="margin-top: 10px;">
                                        <label style="font-size: 16px;font-weight: 300;" class="radio-inline">
                                            <input (click)="priceText = 0; oldPriceText =0;"
                                                formControlName="weightUnit" type="radio" name="weightUnit" value="lbs"
                                                class="ng-pristine ng-valid ng-not-empty ng-touched">
                                            lbs</label>
                                        <label style="margin-left: 10px;font-size: 16px;font-weight: 300;"
                                            class="radio-inline"><input (click)="priceText = 0; oldPriceText =0;"
                                                formControlName="weightUnit" type="radio" name="weightUnit" value="kg"
                                                class="ng-pristine ng-untouched ng-valid ng-not-empty"> kg</label>
                                    </div>

                                </div>
                                <div class="col-12 col-lg-7">
                                    <p
                                        style="color: black;text-align: left;font-size: 16px;font-weight: 300;margin-bottom: 0px;">
                                        My package's dimensions are</p>
                                    <div class="row">
                                        <div style="margin-top: 5px;" class="col-md-4">
                                            <input (keypress)="priceText = 0;oldPriceText =0"
                                                (change)="priceText = 0; oldPriceText =0;" type="number"
                                                formControlName="width"
                                                [ngClass]="{'shippn-border-red':form.get('width').touched && form.get('width').invalid}"
                                                placeholder="Width: 0" class="form-control form-control-sm shippn-input"
                                                onwheel="this.blur()">
                                        </div>
                                        <div style="margin-top: 5px;" class="col-md-4 shippn-padding-none">
                                            <input (keypress)="priceText = 0;oldPriceText =0"
                                                (change)="priceText = 0; oldPriceText =0;" type="number"
                                                formControlName="height"
                                                [ngClass]="{'shippn-border-red':form.get('height').touched && form.get('height').invalid}"
                                                placeholder="Height: 0"
                                                class="form-control form-control-sm shippn-input" onwheel="this.blur()">
                                        </div>
                                        <div style="margin-top: 5px;" class="col-md-4">
                                            <input (keypress)="priceText = 0;oldPriceText =0"
                                                (change)="priceText = 0; oldPriceText =0;" type="number"
                                                formControlName="length"
                                                [ngClass]="{'shippn-border-red':form.get('length').touched && form.get('length').invalid}"
                                                placeholder="Length: 0"
                                                class="form-control form-control-sm shippn-input" onwheel="this.blur()">
                                        </div>
                                    </div>
                                    <div style="margin-top: 10px;">
                                        <label style="font-size: 16px;font-weight: 300;" class="radio-inline"><input
                                                (click)="priceText = 0; oldPriceText =0;"
                                                formControlName="dimensionUnit" type="radio" name="dimensionUnit"
                                                value="inch" class="ng-pristine ng-valid ng-not-empty ng-touched">
                                            inch</label>
                                        <label style="margin-left: 10px;font-size: 16px;font-weight: 300;"
                                            class="radio-inline"><input (click)="priceText = 0; oldPriceText =0;"
                                                formControlName="dimensionUnit" type="radio" name="dimensionUnit"
                                                value="cm" class="ng-pristine ng-untouched ng-valid ng-not-empty">
                                            cm</label>
                                        <span style="font-size: 12px;float: right;" data-toggle="modal"
                                            data-target="#volumetricModal" class="btn btn-link btn-sm">(What is
                                            volumetric weight?)</span>
                                    </div>
                                </div>
                            </div>
                        </form>


                    </div>

                    <div style="background-color: #daecf7;border-color: #daecf7;font-size: 14px;color: #3d85b0;font-weight: 300;margin-top: 10px;margin-bottom: 10px;"
                        class="alert alert-primary" role="alert">
                        It is important to note that the shipping cost is based on the actual weight or volumetric
                        weight - whichever is greater. Volumetric weight is
                        calculated by multiplying the width, length and height of your package.
                    </div>

                    <div *ngIf="countryFrom == 'US' && countryTo == 'TR'">
                        <h4 style="font-size: 18px;font-weight: bold;margin-bottom: 27px;color: black;">Use our local
                            mail forwarding service in Türkiye:</h4>

                        <p
                            style="color: black;text-align: left;font-size: 16px;font-weight: 300;margin-top: 10px;margin-bottom: 40px;">
                            Amerikadaniste for best shipping rates. <br> Create your Amerikadaniste account to start
                            your 30 days free trial.</p>

                        <div>
                            <img style="width: 165px;margin-bottom: 15px;margin-right: 10px;"
                                src="../../assets/img/ai-logo-black.png" alt="Amerikadan iste black logo">
                            <a href="https://www.amerikadaniste.com" target="_blank" rel="external nofollow"
                                style="margin-bottom: 15px;" class="btn shippn-from-to-area-go-btn">Create Your
                                Amerikadaniste account now</a>

                        </div>

                    </div>


                </div>

                <div [hidden]="countryFrom == 'US' && countryTo == 'TR'"
                    style="position:sticky; bottom:0; background-color: #414141;border-bottom-left-radius: 5px;border-bottom-right-radius: 5px;padding-top: 20px;padding-bottom: 20px;padding-left: 15px;padding-right: 15px;">

                    <div [hidden]="countryFrom == 'US' && countryTo == 'TR'" class="row" style="margin-bottom: 10px;">
                        <div style="text-align: center;"
                            class="col-md-12 d-block d-sm-block d-xs-block d-md-block d-lg-none">


                            <div style="display: flex; align-items: center; justify-content: space-around;">
                                <div *ngIf="isThereADiscount && oldPriceText > 0">
                                    <h5
                                        style="font-size: 16px;font-weight: 400; padding-right: 10px;  height: 100%;display: flex; flex-direction: column; gap: 5px; color: #fff; align-items: center; justify-content: center; margin:0;">
                                        <span>Remaining time</span>
                                        <span class="remaining-time-span">{{
                                            remainingTime?.minutes | number: '2.0-0' }} : {{ remainingTime?.seconds |
                                            number: '2.0-0'
                                            }}</span>
                                    </h5>
                                </div>
                                <div>
                                    <h3 style="color: white;font-size: 21px;font-weight: 300;margin: 0;">Best price is
                                    </h3>
                                    <h5 style="font-size: 14px;font-weight: bold;color: #e60000;margin-bottom: 0px;margin-top: 5px; text-decoration: line-through;"
                                        *ngIf="isThereADiscount && oldPriceText > 0">
                                        {{oldPriceText | number:'1.2-2'}} USD</h5>
                                    <span style="font-size: 18px;font-weight: bold;color: white;" translate="no"
                                        [ngStyle]="{'color': isThereADiscount && oldPriceText > 0 ? '#94ff94': 'white'}">{{priceText
                                        |
                                        number:'1.2-2'}}
                                        USD</span>
                                </div>
                            </div>






                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-7 d-none d-sm-none d-xs-none d-md-none d-lg-block">
                            <div style="display: inline-flex;height: 100%;align-items: center;">
                                <div>
                                    <button *ngIf="!isLoading" (click)="calculatePrice()"
                                        class="btn shippn-from-to-area-go-btn">Calculate</button>
                                    <button *ngIf="isLoading"
                                        style="background-image: url(../../assets/img/loading-white.gif);background-repeat: no-repeat;background-position: center;height: 38px;width: 90.48px;"
                                        class="btn shippn-from-to-area-go-btn"></button>
                                </div>
                                <div>
                                    <button [routerLink]="['/',lang,'shop-from',countryFrom]"
                                        style="margin-left: 15px;background-color: transparent;border: 1px solid white;color: white;"
                                        class="btn ">Create Order</button>
                                </div>
                            </div>


                        </div>
                        <div style="text-align: right;"
                            class="col-md-5 d-none d-sm-none d-xs-none d-md-none d-lg-block">


                            <div style="display: flex; gap: 15px; align-items: center; justify-content: flex-end;">
                                <div *ngIf="isThereADiscount && oldPriceText > 0">
                                    <h5
                                        style="font-size: 16px;font-weight: 400; padding-right: 10px; border-right: 1px solid #fff; height: 100%;display: flex; flex-direction: column; gap: 5px; color: #fff; align-items: center; justify-content: center; margin:0;">
                                        <span>Remaining time</span>
                                        <span class="remaining-time-span">{{
                                            remainingTime?.minutes | number: '2.0-0' }} : {{ remainingTime?.seconds |
                                            number: '2.0-0'
                                            }}</span>
                                    </h5>
                                </div>



                                <div>
                                    <h3 style="color: white;font-size: 21px;font-weight: 300;margin: 0;">Best price is
                                    </h3>
                                    <h5 style="font-size: 14px;font-weight: bold;color: #e60000;margin-bottom: 0px;margin-top: 5px; text-decoration: line-through;"
                                        *ngIf="isThereADiscount && oldPriceText > 0">
                                        {{oldPriceText | number:'1.2-2'}} USD</h5>
                                    <span style="font-size: 18px;font-weight: bold;color: white;" translate="no"
                                        [ngStyle]="{'color': isThereADiscount && oldPriceText > 0 ? '#94ff94': 'white'}">{{priceText
                                        |
                                        number:'1.2-2'}}
                                        USD</span>
                                </div>
                            </div>
                        </div>


                        <div class="col-6 d-block d-sm-block d-xs-block d-md-block d-lg-none">
                            <div>
                                <button style="width: 100%;" *ngIf="!isLoading" (click)="calculatePrice()"
                                    class="btn shippn-from-to-area-go-btn">Calculate</button>
                                <button *ngIf="isLoading"
                                    style="background-image: url(../../assets/img/loading-white.gif);background-repeat: no-repeat;background-position: center;height: 38px;width: 100%"
                                    class="btn shippn-from-to-area-go-btn"></button>
                            </div>

                        </div>
                        <div class="col-6 d-block d-sm-block d-xs-block d-md-block d-lg-none">
                            <div>
                                <button [hidden]="countryFrom == 'US' && countryTo == 'TR'"
                                    [routerLink]="['/', lang, 'shop-from', countryFrom]"
                                    style="background-color: transparent;border: 1px solid white;color: white;width: 100%;"
                                    class="btn ">Create Order</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container shippn-homepage-container" style="margin-top: 20px;" *ngIf="hasCourierOptions"> 
    <div class="row">
        <div class="col-md-12"> 
            <div class="alert alert-warning">
                <p style="font-size: 14px;margin:0;">
                    <i class="fas fa-info-circle"></i> Please note that insurance, is not included in the displayed prices. It will be calculated separately and the final cost may vary based on your item’s value.”
                </p>
            </div>
        </div>
    </div>

</div>

<div *ngIf="hasCourierOptions" style="margin-top: 20px;transition: 1s;" class="container shippn-homepage-container">
    <div class="row">
        <div class="col-md-12">
            <div style="background-color: #eaeaea;border-radius: 5px;box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);">
                <div class="table-responsive">
                    <table class="table table-borderless">
                        <thead>
                            <tr style="border-bottom: 1px solid #70707036;">
                                <th style="font-size: 22px;" colspan="4">
                                    Courier Options

                                </th>
                            </tr>
                            <tr style="border-bottom: 1px solid #70707036;">
                                <th scope="col">Company</th>
                                <th scope="col">Service Type</th>
                                <th scope="col">Estimated Delivery Time</th>
                                <th scope="col">Price (including host fee)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of courierData;">
                                <td>
                                    <img *ngIf="data.company_id == 1" style="width: 65px;" src="../../assets/tnt.png"
                                        alt="tnt logo">
                                    <img *ngIf="data.company_id == 2" style="width: 65px;" src="../../assets/ups.png"
                                        alt="ups logo">
                                    <img *ngIf="data.company_id == 3" style="width: 65px;" src="../../assets/dhl.png"
                                        alt="dhl logo">
                                    <img *ngIf="data.company_id == 4" style="width: 65px;" src="../../assets/fedex.png"
                                        alt="fedex logo">
                                    <img *ngIf="data.company_id == 5" style="width: 65px;"
                                        src="../../assets/auspost.png" alt="auspost logo">
                                    <img *ngIf="data.company_id == 6" style="width: 65px;" src="../../assets/usps.png"
                                        alt="usps logo">
                                    <img *ngIf="data.company_id == 7" style="width: 65px;" src="../../assets/aramex.png"
                                        alt="aramex logo">
                                    <img *ngIf="data.company_id == 8" style="width: 65px;"
                                        src="../../assets/laposte.png" alt="laposte logo">
                                    <img *ngIf="data.company_id == 12" style="width: 65px;" src="../../assets/ems.png"
                                        alt="Shippn Partner EMS logo">
                                    <img *ngIf="data.company_id == 13" style="width: 65px;" src="../../assets/dpd.png"
                                        alt="Courier DPD logo">
                                    <img *ngIf="data.company_id == 14" style="width: 60px;" src="../../assets/evri.webp"
                                        alt="Courier Evri logo">
                                </td>
                                <td>{{data.service_type_name}}</td>
                                <td>{{data.estimated_delivery}} Business Days</td>
                                <td style="font-weight: bold;" translate="no">{{data.total_shipment_amount}} USD</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>



<div style="margin-top: 20px;" class="container shippn-homepage-container">

    <div class="row">
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon.png"
                        alt="tshirt shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">T-shirt
                </h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-2.png"
                        alt="Sweater shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Sweater
                </h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-3.png"
                        alt="pants shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Pants
                </h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-4.png"
                        alt="coat shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Coat</h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">2 - 4 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-5.png"
                        alt="shoes shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Shoes
                </h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-6.png"
                        alt="sneakers shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Sneakers
                </h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-7.png"
                        alt="boots shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Boots
                </h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">1 -2 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-8.png"
                        alt="bag shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Bag</h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1,5 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-9.png"
                        alt="Accessories shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">
                    Accessories</h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-10.png"
                        alt="makeup set shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Makeup
                    Set</h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-11.png"
                        alt="glasses shipping price calculation" class="img-responsive">
                </div>

                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Glasses
                </h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-12.png"
                        alt="card games shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Card
                    Games</h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-13.png"
                        alt="book shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Book</h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-14.png"
                        alt="camera shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Camera
                </h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-15.png"
                        alt="e-reader shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">E-reader
                </h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-16.png"
                        alt="tablet shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Tablet
                </h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-17.png"
                        alt="phone shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">Phone
                </h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 kg</h5>
            </div>
        </div>
        <div style="text-align: center;" class="col-3 col-sm-3 col-md-4 col-lg-2">
            <div style="margin-top:10px;padding:10px">
                <div style="height: 65px;display: inline-flex;align-items: flex-end;text-align: center;">
                    <img style="width: 100%;" src="../../assets/img/pricing-icon-18.png"
                        alt="vr headset shipping price calculation" class="img-responsive">
                </div>
                <h5 style="text-align: center;font-size: 14px;color: #333;margin-top: 20px;font-weight: bold;">VR
                    Headset</h5>
                <h5 style="text-align: center;font-size: 14px;color: #333;font-weight: 300;">0,5 - 1 kg</h5>
            </div>
        </div>
    </div>

</div>

<div class="container shippn-homepage-container">
    <div class="row">
        <div class="col-md-12">
            <div style="background-color: #daecf7;border-color: #daecf7;font-size: 14px;color: #3d85b0;font-weight: 300;margin-top: 30px;margin-bottom: 30px;"
                class="alert alert-primary" role="alert">
                <h4 style="font-weight: bold;">International Shipping Cost Calculator: Your Guide to Affordable and
                    Accurate Shipping Rates</h4>
                <p>
                    Understanding <strong>international shipping costs</strong> can often feel overwhelming. Whether you’re an individual
                    sending personal packages or a business managing global logistics, balancing <strong>shipping fees</strong> and
                    reliability is essential. This is where Shippn’s <strong>international shipping calculator</strong> makes a
                    difference, providing accurate <strong>shipping estimates</strong> and competitive rates tailored to your needs.
                </p>
                <h6>Why Choose Shippn for International Shipping?</h6>
                <p>
                    Shippn redefines the <strong>international shipping experience</strong> with its transparent pricing and
                    user-friendly interface. Unlike competitors, we ensure clarity, leaving no room for hidden fees or
                    unexpected charges.
                </p>
                <ul>
                    <li><strong>Clear Pricing:</strong> Know exactly what you’re paying for. No hidden charges mean you can budget
                        confidently.
                    </li>
                    <li>
                        <strong>Convenience at Your Fingertips:</strong> Whether it’s estimating shipping costs from the US to the UK or
                        checking international delivery fees, our calculator simplifies the process.
                    </li>
                    <li>
                        <strong>Tailored Solutions:</strong> Choose from various options based on speed, weight, and preferences.
                    </li>
                </ul>
                <h6>Key Benefits of Shippn’s Shipping Calculator</h6>
                <ol>
                    <li><strong>Detailed Shipping Estimates:</strong> From overseas shipping costs to international delivery fees, we
                        give you a comprehensive view of your shipping expenses.</li>
                    <li><strong>Global Reach:</strong> Whether you’re calculating shipping costs from the US to the UK or sending
                        packages to Europe, Shippn handles destinations worldwide.</li>
                    <li><strong>Customizable Options:</strong> Adjust delivery speed, weight, and preferences to match your needs.</li>
                    <li><strong>Competitive Rates:</strong> Compare international shipping fees with ease and secure the best deals.</li>
                    <li><strong>Real-Time Accuracy:</strong> Avoid surprises by accessing real-time updates on rates and fees.</li>
                </ol>
                <h6>How to Use Shippn’s International Shipping Calculator</h6>
                <p>
                    Using Shippn’s calculator is a breeze. Follow these simple steps to get started:
                </p>
                <ol>
                    <li><strong>Select Destination:</strong> Choose the delivery country from the dropdown menu.</li>
                    <li><strong>Enter Package Details:</strong> Provide the weight, dimensions, and type of shipment. This ensures
                        precise <strong>international shipping quotes</strong> tailored to your needs.</li>
                    <li><strong>View Costs:</strong> Instantly access a detailed breakdown of shipping charges and fees.</li>
                </ol>
                <h6>Why Accurate Shipping Estimates Matter</h6>
                <p>Unexpected costs can derail your plans, whether you’re shipping a gift to a loved one or managing
                    business logistics. With Shippn’s online shipping calculator, you gain clarity and control over your
                    expenses.</p>
                <h6>Advantages of Accurate Estimates:</h6>
                <ul>
                    <li><strong>Budget-Friendly Options:</strong> Know your <strong>international shipping price</strong> upfront to plan effectively.
                    </li>
                    <li><strong>Efficient Logistics:</strong> Streamlined processes reduce delays caused by incorrect information.</li>
                    <li><strong>Informed Comparisons:</strong> Confidently compare international shipping costs to secure the best rates.
                    </li>
                </ul>
                <h5>Popular Use Cases for Shippn’s Calculator</h5>
                <h6>1. Sending Packages Overseas</h6>
                <p>
                    Whether you’re sending a care package to family or shipping gifts to friends abroad, Shippn provides
                    accurate <strong>estimated shipping costs</strong> so you can pick the most affordable option without compromising on
                    delivery speed or reliability.
                </p>
                <h6>2. E-Commerce Businesses</h6>
                <p>
                    For businesses selling globally, managing <strong>international shipping fees</strong> effectively is critical to
                    ensuring competitive pricing and customer satisfaction. Shippn’s calculator helps you provide
                    accurate shipping quotes, improving transparency and trust with your customers.
                </p>
                <h6>3. Bulk Shipping or Freight</h6>
                <p>
                    Need to ship large volumes? Use Shippn to calculate <strong>international freight estimates</strong> and enjoy
                    discounts for bulk shipments. Tailor the delivery to fit your budget and timeline.
                </p>
                <h5>
                    Affordable Shipping to Popular Destinations
                </h5>
                <p>Shippn offers competitive rates for popular shipping routes, ensuring cost-effective solutions no
                    matter your destination.</p>
                <ul>
                    <li><strong>Shipping Costs to Europe:</strong> From Germany to Spain, get affordable rates and quick delivery.</li>
                    <li><strong>US to UK Shipping Costs:</strong> Simplify cross-Atlantic shipping with precise shipping estimates and
                        freight options.</li>
                    <li><strong>Shipping to Canada:</strong> Calculate the cost of sending packages to Canada with full transparency on
                        fees and delivery times.</li>
                    <li><strong>Worldwide Coverage:</strong> Whether shipping to Asia, Australia, or South America, Shippn covers all
                        corners of the globe.</li>
                </ul>
                <h5>Frequently Asked Questions</h5>
                <h6>How much does it cost to ship a package internationally?</h6>
                <p>
                    The cost varies based on weight, dimensions, and destination. With <strong>Shippn</strong>, you can use our <strong>shipping
                        cost calculator</strong> to get a quick, accurate estimate tailored to your needs. Shippn ensures transparent
                    pricing, so you always know what to expect.
                </p>
                <h6>What is the difference between international shipping fees and postage costs?</h6>
                <p>Shipping fees often include additional charges like handling, customs, and packaging, while postage
                    costs are specific to mailing services. <strong>Shippn simplifies this process</strong> by offering an all-inclusive
                    pricing structure, so you can focus on your shopping and shipping without surprises.
                </p>
                <h6>How does Shippn compare with other services?</h6>
                <p>
                    Shippn’s <strong>competitive pricing</strong>, <strong>global reach</strong>, and <strong>customer-friendly policies</strong> make it the go-to choice
                    for international shipping. Unlike other services, Shippn provides a seamless experience with
                    accurate estimates, no hidden fees, and reliable delivery to 39+ countries.
                </p>
                <h6>Do I have to pay volumetric weight charges when shipping internationally?</h6>
                <p>Yes, volumetric weight charges apply when the package’s size exceeds its actual weight. With <strong>Shippn</strong>,
                    our calculator ensures you get the best possible rates, whether the cost is based on size or weight.
                </p>
                <h6>How can I estimate international shipping costs?</h6>
                <p>
                    Simply input your package’s details into <strong>Shippn’s shipping cost calculator</strong> for an instant, accurate
                    quote. This tool eliminates guesswork, helping you budget for your shipping needs.
                </p>
                <h6>What is the cheapest way to ship things internationally?</h6>
                <p>The cheapest method depends on your package’s specifics. With <strong>Shippn</strong>, you gain access to economy and
                    standard shipping options, ensuring affordability without compromising reliability.</p>
                <h6>How much does it cost to ship something internationally?</h6>
                <p>
                    Shipping costs depend on factors like distance, weight, and size. Additional charges, such as
                    customs fees, may also apply. With <strong>Shippn</strong>, you get transparent pricing and cost-effective options,
                    making international shipping stress-free.
                </p>
                <h6>Is it cheaper to ship by weight or size?</h6>
                <p>
                    It depends on the carrier’s pricing structure. <strong>Shippn provides clarity</strong> by calculating costs based on
                    actual or volumetric weight, ensuring you pay the most reasonable rate.
                </p>

                <h5>Why Shippn Stands Out Among International Shipping Carriers</h5>
                <p>Competing with services like MyUS, Shippn leads the market in transparency, affordability, and customer service. Here’s why Shippn is the preferred choice:</p>
                <ul>
                    <li><strong>No Hidden Costs:</strong> Get clear and upfront pricing every time.</li>
                    <li><strong>Global Accessibility:</strong> Ship from anywhere to 39+ countries.</li>
                    <li><strong>Reliability:</strong> Enjoy safe, secure, and timely deliveries.</li>
                    <li><strong>Competitive Pricing:</strong> Save on international shipping rates with our tailored solutions.</li>
                </ul>
                <p>
                    Whether you’re estimating <strong>shipping costs from the US to the UK</strong>, <strong>comparing international shipping rates</strong>, or calculating the <strong>cost of shipping a phone internationally</strong>, Shippn provides the tools and support to make global shipping stress-free.
                </p>
                <h5>Start Saving with Shippn</h5>
                <p>Take control of your international shipping today. By using Shippn’s international shipping calculator, you gain:</p>
                <ul>
                    <li><strong>Real-Time Quotes:</strong> Plan your shipping budget effectively with accurate, up-to-date estimates.</li>
                    <li><strong>Flexible Options:</strong> Access solutions for standard, express, or economy shipping.</li>
                    <li><strong>Global Coverage:</strong> Calculate rates to popular destinations worldwide.</li>
                </ul>
                <p>
                    Simplify your shipping process with Shippn. Get started now and see why we’re the trusted choice for individuals and businesses alike. Let Shippn take the hassle out of international shipping while saving you time and money.
                </p>
                <p>
                    <a [routerLink]="['/signup']" style="font-weight: bold;">Sign up</a> Shippn today! Your gateway to affordable, accurate, and reliable global shipping awaits.
                </p>
                
                <!-- <p>
                    Please note that the shipping cost is determined by either the actual weight or the volumetric
                    weight of your package, whichever is greater. Volumetric weight is calculated by multiplying the
                    width, length, and height of your package. If the package's weight includes a fraction, it will be
                    rounded up to the next whole pound or the next half kilogram in accordance with international
                    shipping regulations. For example, a package weighing 2.3 kg will be calculated as 2.5 kg, and a
                    package weighing 2.3 lbs will be calculated as 3 lbs.
                    <br>
                    <br>
                    Your item may not require customs clearance. Customs fees and duties are determined based on the
                    contents and value of your items, as well as your country's regulations. We will provide additional
                    information about customs and duties, if necessary, when your package arrives at our host.
                    <br>
                    <br>
                    For tax and duties information or any other inquiries, please contact our customer service team.
                </p> -->


            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="volumetricModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div style="max-width: 800px;" class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">What is Volumetric Weight</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-sm-12 text-center"><img width="300" src="../../assets/img/volumetric.png"
                            alt="Volumetric weight"></div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <table style="background-color: #ff6c365e !important;" class="table text-center bg-warning">
                            <tr>
                                <td width="150" class="text-right">Dimensional weight<br>(lbs)</td>
                                <td width="10" style="line-height: 3em">=</td>
                                <td>L x W x H
                                    <hr style="border-color:#000; margin: 0">139
                                </td>
                            </tr>
                        </table>
                        <div class="text-center">L = Length in inches<br>W = Width in inches<br>H = Height in inches<br>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <table style="background-color: #ff6c365e !important;" class="table text-center bg-warning">
                            <tr>
                                <td width="150" class="text-right">Dimensional weight<br>(kg)</td>
                                <td width="10" style="line-height: 3em">=</td>
                                <td>L x W x H
                                    <hr style="border-color:#000; margin: 0">5000
                                </td>
                            </tr>
                        </table>
                        <div class="text-center">L = Length in centimeters<br>W = Width in centimeters<br>H = Height in
                            centimeters<br></div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>



<!-- Get New Adress -->

<!-- <button class="btn shippn-from-to-area-go-btn" id="bf2022ModalTrigger" data-toggle="modal"
    data-target="#getNewAdressModal" style="display: none !important; ">
    <i class="fas fa-plus"></i>
</button> -->

<!-- Get New Adress Modal -->
<!-- Modal -->
<div class="modal fade " id="getNewAdressModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div style="background: #222222;" class="modal-header">
                <div style="display: inline-flex;align-items: center;">

                    <h5 style="color: #fff;padding-left: 15px; text-align: center;" class="modal-title"
                        id="exampleModalLabel">
                        Black Friday is Here! </h5>
                </div>

                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span style="color: white;" aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="row">
                        <div class="card-body" style="padding: 0px;">

                            <p style="text-align: center; margin:0">
                                Use the "<strong (click)="copyBF()" style="color: #3d85b0;">FIRST15</strong>" code for
                                <strong>$15</strong> cashback!
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer" style="display: flex; justify-content: center; align-items: center;">
                <a target="_blank" href="/{{lang}}/shop-from/{{countryFrom}}" class="btn shippn-from-to-area-go-btn"
                    *ngIf="loggedUser == true">SHOP NOW</a>
                <a target="_blank" href="https://www.shippn.com/hello10?utm_source=calculate&utm_campaign=popup"
                    class="btn shippn-from-to-area-go-btn" *ngIf="loggedUser == false">GET STARTED NOW</a>

            </div>

        </div>
    </div>
</div>


<button data-toggle="modal" id="icdcModalTrigger" data-target="#icdcModal" aria-hidden="true" style="display: none;">
</button>

<div class="modal fade" id="icdcModal" tabindex="-1" aria-labelledby="Shipping Cost Calculator Discount"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel" style="font-size: 16px;">
                    Awesome News! You've Got 10% Discount!
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="icdcModalCloseTrigger">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p style="color: black;text-align: center;font-size: 16px;font-weight: 300;margin-bottom: 5px;">
                    Create your order now!
                </p>
                <p style="text-align: center; font-weight: 300; color: #000; margin-bottom: 5px; font-size: 16px;">
                    Only For 10 Minutes, Don't Miss Out!
                </p>
                <p style="font-size: 18px; text-align: center;color:black; font-weight: 400;">
                    <span class="remaining-time-span">{{
                        remainingTime?.minutes | number: '2.0-0' }} : {{ remainingTime?.seconds | number: '2.0-0'
                        }}</span>
                </p>
            </div>
            <div class="modal-footer">
                <button style="float: right;" class="btn shippn-from-to-area-go-btn" data-dismiss="modal"
                    (click)="goToDiscountedShopFrom()">Create Order</button>
            </div>
        </div>
    </div>
</div>